if (typeof VideoBackgroundElement !== 'function') {

  class VideoBackgroundElement extends HTMLElement {

    constructor() {
      super();

      this._eventSuccess = new Event('success');
      this._eventFail = new Event('fail');
      this._loaded = false;

      const video = this.querySelector('video');

      video.addEventListener('error', () => {
        this.switchFallback();
      });

      video.addEventListener('playing', () => {
        if (!this._loaded) {
          this._loaded = true;
          this.classList.add('loaded');
          this.dispatchEvent(this._eventSuccess);
        }
      });

      video.addEventListener('stalled', () => {
        if (!this._loaded) {
          this.switchFallback();
        }
      });

      // Attempt to play with retry for browsers that delay autoplay
      video.addEventListener('canplay', () => {
        const playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.catch(() => {
            // Retry once after short delay
            setTimeout(() => {
              video.play().catch(() => {
                this.switchFallback();
              });
            }, 300);
          });
        }
      });

      this._loadSources(video);
    }

    _loadSources(video) {
      const isInViewport = (
        this.getBoundingClientRect().y < window.innerHeight ||
        (this.parentElement && this.parentElement.getBoundingClientRect().y < window.innerHeight)
      );

      if (isInViewport) {
        this._setSources(video);
      } else {
        const handleIntersection = (entries, observer) => {
          const entry = entries[0];
          if (!entry.isIntersecting) return;

          if (!this._loaded) {
            this._setSources(video);
          }

          observer.unobserve(entry.target);
        };

        const observerOptions = { rootMargin: '0px 0px 400px 0px' };

        new IntersectionObserver(handleIntersection, observerOptions).observe(this);

        if (this.parentElement) {
          new IntersectionObserver(handleIntersection, observerOptions).observe(this.parentElement);
        }
      }
    }

    _setSources(video) {
      video.querySelectorAll('source[data-src]').forEach(source => {
        if (!source.src || source.src === window.location.href) {
          source.src = source.dataset.src;
        }
      });
      video.load();
    }

    switchFallback() {
      const fallback = this.parentElement
        ? this.parentElement.querySelector(`[data-video-background-fallback][data-id="${this.dataset.id}"]`)
        : null;

      if (fallback) {
        const template = fallback.querySelector('template');
        if (template) {
          fallback.append(template.content.cloneNode(true));
          const img = fallback.querySelector('img');
          if (img) {
            img.setAttribute('srcset', img.getAttribute('srcset'));
          }
        }
      }

      this.dispatchEvent(this._eventFail);
    }
  }

  if (typeof customElements.get('video-background-element') === 'undefined') {
    customElements.define('video-background-element', VideoBackgroundElement);
  }
}

// Handle Shopify theme editor section reloads
document.addEventListener('shopify:section:load', e => {
  if (e.target.classList.contains('mount-video-background')) {
    setTimeout(() => {
      e.target.querySelectorAll('video-background-element').forEach(elm => {
        const video = elm.querySelector('video');
        if (!video) return;

        elm.querySelectorAll('source[data-src]').forEach(source => {
          source.src = source.dataset.src;
        });

        video.load();

        video.play().catch(() => {
          setTimeout(() => video.play().catch(() => {}), 500);
        });
      });
    }, 500);
  }
});